import {
  ACKNOWLEDGMENT_NODE,
  CHALLENGE_BRANCH_AI,
  CHALLENGE_BRANCH_QUESTION,
  CHOICE_TEXT_QUESTION,
  LessonContentAcknowledgment,
  LessonContentMChoice,
  LessonContentVideo,
  MULTIPLE_CHOICE,
  OPENENDED_QUESTION_NODE_TYPE,
  OVERLAY_VIDEO_TYPE,
  RECORD_VIDEO_TYPE,
  VIDEO_NODE_TYPE,
} from '../../../data/models/LessonContent/LessonContentBase';
import {LessonContentList} from '../../../data/models/LessonContent/LessonContentList';

export interface ReelMeta {
  durationSeconds: number;
  questionCount: number;
}

// Generation settings the backend copies onto each reel lesson; empty for
// groups generated before the backend change.
export interface ReelGenerationMeta {
  language?: string;
  dialect?: string;
  gender?: string;
}

const PLAYABLE_NODE_TYPES = [
  VIDEO_NODE_TYPE,
  OVERLAY_VIDEO_TYPE,
  RECORD_VIDEO_TYPE,
];

const QUESTION_NODE_TYPES = [
  CHOICE_TEXT_QUESTION,
  MULTIPLE_CHOICE,
  CHALLENGE_BRANCH_QUESTION,
  CHALLENGE_BRANCH_AI,
  OPENENDED_QUESTION_NODE_TYPE,
];

export const getReelMeta = (lessonContent?: LessonContentList): ReelMeta => {
  const items = lessonContent?.contentList?.items;
  let durationSeconds = 0;
  let questionCount = 0;
  if (items) {
    Object.values(items).forEach(item => {
      const type = item.data.ivNodeType;
      if (QUESTION_NODE_TYPES.includes(type)) {
        questionCount += 1;
        return;
      }
      if (PLAYABLE_NODE_TYPES.includes(type)) {
        const node = item.data as LessonContentVideo;
        const trimmed = (node.endInSeconds ?? 0) - (node.startInSeconds ?? 0);
        durationSeconds +=
          trimmed > 0 ? trimmed : Math.max(node.durationInseconds ?? 0, 0);
      }
    });
  }
  return {durationSeconds, questionCount};
};

export const getMicroreelQuestion = (
  lessonContent?: LessonContentList,
): LessonContentMChoice | undefined => {
  const items = lessonContent?.contentList?.items;
  if (!items) return undefined;
  return Object.values(items)
    .map(item => item.data)
    .find(data => data.ivNodeType === MULTIPLE_CHOICE) as
    | LessonContentMChoice
    | undefined;
};

export const getMicroreelAckNode = (
  lessonContent?: LessonContentList,
): LessonContentAcknowledgment | undefined => {
  const items = lessonContent?.contentList?.items;
  if (!items) return undefined;
  return Object.values(items)
    .map(item => item.data)
    .find(data => data.ivNodeType === ACKNOWLEDGMENT_NODE) as
    | LessonContentAcknowledgment
    | undefined;
};

export const formatReelDuration = (seconds: number) => {
  const total = Math.round(seconds);
  const minutes = Math.floor(total / 60);
  const remainder = total % 60;
  return `${minutes}:${remainder.toString().padStart(2, '0')}`;
};

export const formatReelDurationLong = (seconds: number) => {
  const total = Math.round(seconds);
  const minutes = Math.floor(total / 60);
  const remainder = total % 60;
  if (!minutes) {
    return `${remainder} sec`;
  }
  return `${minutes} min ${remainder} sec`;
};
